import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { ReservationCancellationReason } from './reservation-cancellation-reason.model';
import { ReservationCancellationReasonService } from './reservation-cancellation-reason.service';

@Component({
    selector: 'jhi-reservation-cancellation-reason-detail',
    templateUrl: './reservation-cancellation-reason-detail.component.html'
})
export class ReservationCancellationReasonDetailComponent implements OnInit, OnDestroy {

    reservationCancellationReason: ReservationCancellationReason;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private reservationCancellationReasonService: ReservationCancellationReasonService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['reservationCancellationReason']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load(id) {
        this.reservationCancellationReasonService.find(id).subscribe(reservationCancellationReason => {
            this.reservationCancellationReason = reservationCancellationReason;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-cancellation-reason/reservation-cancellation-reason-detail.component.ts